/* global KIEV_TIMEZONE */
const moment = require('moment-timezone/moment-timezone');

moment.tz.add(KIEV_TIMEZONE);

module.exports = moment;
